import request from '@/utils/request'

// 获取当前用户关联的社区ID
export function getCommunityId() {
  return request({
    url: '/homeservice/bill/getCommunityId',
    method: 'get'
  })
}

// 查询账单分页
export function pageBill(data) {
  return request({
    url: '/homeservice/bill/page',
    method: 'post',
    data: data
  })
}

// 查询账单列表
export function listBill(query) {
  return request({
    url: '/homeservice/bill/list',
    method: 'get',
    params: query
  })
}

// 查询账单详情
export function getBill(data) {
  return request({
    url: '/homeservice/bill/detail',
    method: 'get',
    params: data
  })
}

// 新增账单
export function addBill(data) {
  return request({
    url: '/homeservice/bill/add',
    method: 'post',
    data: data
  })
}

// 修改账单
export function updateBill(data) {
  return request({
    url: '/homeservice/bill/edit',
    method: 'post',
    data: data
  })
}

// 删除账单
export function delBill(data) {
  return request({
    url: '/homeservice/bill/delete',
    method: 'post',
    data: data
  })
}

// 导出账单
export function exportBill(data) {
  return request({
    url: '/homeservice/bill/export',
    method: 'post',
    data: data
  })
}

// 查询社区绑定的用户列表
export function getUserCommunityList(communityId) {
  return request({
    url: '/homeservice/bill/userCommunityList',
    method: 'get',
    params: { communityId: communityId }
  })
}
